import { useState } from "react";
import * as Yup from "yup";
import { Formik } from "formik";
import { LoadingButton } from "@mui/lab";
import {
  EmailOutlined,
  LockOutlined,
  VisibilityOffOutlined,
  VisibilityOutlined,
} from "@mui/icons-material";

import { fetchUserToken } from "../../redux/api/auth.api";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import "../../styles/login.scss";

const loginSchema = Yup.object().shape({
  email: Yup.string()
    .min(3, "Minim 3 caractere")
    .max(50, "Maxim 50 caractere")
    .email("Adăugați un email valid"),
  password: Yup.string()
    .min(3, "Minim 3 caractere")
    .max(50, "Maxim 50 caractere")
    .required("Adăugați o parolă"),
});

const initialValues = { email: "", password: "" };

const Login = () => {
  const dispatch = useAppDispatch();
  const [showPassword, setShowPassword] = useState(false);

  const {
    auth: { isLoadingToken },
    user: { isLoadingUser },
  } = useAppSelector((state) => ({ auth: state.auth, user: state.user }));

  const isLoading = isLoadingToken || isLoadingUser;

  const handleLogin = (values: typeof initialValues) => {
    dispatch(
      fetchUserToken({
        email_client: values.email,
        password: values.password,
      }),
    );
  };

  return (
    <div className="login-page">
      <main className="login-main">
        <section className="login-card" aria-labelledby="login-title">
          <a
            href="https://www.ahead-translog.ro"
            target="_blank"
            rel="noopener noreferrer">
            <img className="login-logo" src="/logo.svg" alt="Ahead Translog" />
          </a>
          <div className="login-card-heading text-center">
            <span className="login-eyebrow">
              PLATFORMA TMS@ATS PENTRU CLIENTI
            </span>
            <h1 id="login-title">Bine ai revenit</h1>
            <p>Autentificare - Gestionarea transporturilor companiei tale</p>
          </div>

          <Formik
            initialValues={initialValues}
            validationSchema={loginSchema}
            onSubmit={handleLogin}>
            {({
              status,
              errors,
              touched,
              getFieldProps,
              handleSubmit,
              isSubmitting,
            }) => (
              <form className="login-form" onSubmit={handleSubmit} noValidate>
                {status && <div className="login-alert">{status}</div>}

                <div className="login-field">
                  <label htmlFor="login-email">Email</label>
                  <div
                    className={`login-input ${
                      touched.email && errors.email ? "is-invalid" : ""
                    }`}>
                    <EmailOutlined aria-hidden="true" />
                    <input
                      id="login-email"
                      type="email"
                      autoComplete="username"
                      placeholder="nume@companie.ro"
                      autoFocus
                      {...getFieldProps("email")}
                    />
                  </div>
                  {touched.email && errors.email && (
                    <span className="login-error">{errors.email}</span>
                  )}
                </div>

                <div className="login-field">
                  <label htmlFor="login-password">Parolă</label>
                  <div
                    className={`login-input ${
                      touched.password && errors.password ? "is-invalid" : ""
                    }`}>
                    <LockOutlined aria-hidden="true" />
                    <input
                      id="login-password"
                      type={showPassword ? "text" : "password"}
                      autoComplete="current-password"
                      placeholder="Introdu parola"
                      {...getFieldProps("password")}
                    />
                    <button
                      className="password-toggle"
                      type="button"
                      aria-label={
                        showPassword ? "Ascunde parola" : "Arată parola"
                      }
                      onClick={() => setShowPassword((visible) => !visible)}>
                      {showPassword ? (
                        <VisibilityOffOutlined />
                      ) : (
                        <VisibilityOutlined />
                      )}
                    </button>
                  </div>
                  {touched.password && errors.password && (
                    <span className="login-error">{errors.password}</span>
                  )}
                </div>

                <LoadingButton
                  type="submit"
                  className="login-submit"
                  disabled={isLoading}
                  loading={isLoading}>
                  Autentificare
                </LoadingButton>
              </form>
            )}
          </Formik>
        </section>
      </main>
    </div>
  );
};

export default Login;
